import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
	FLUSH,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
	REHYDRATE,
	persistReducer,
	persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { loadingReducer } from 'src/components/common/loading/loadingSlice';
import { snackbarReducer } from 'src/components/common/snackbar/snackbarSlice';
import { annotationTemplateReducer } from 'src/features/annotation_template';
import { authReducer } from 'src/features/auth';
import { jobReducer } from 'src/features/job';
import { patientReducer } from 'src/features/patient';
import { userProfileReducer } from 'src/features/profile';
import { questionnaireTemplateReducer } from 'src/features/questionnaire_template';
import { siteReducer } from 'src/features/site';
import { studyReducer } from 'src/features/study';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: [
		'auth',
		'site',
		'user_profile',
		'questionnaire_template',
		'annotation_template',
		'patient',
		'study',
	],
};

const appReducers = combineReducers({
	auth: authReducer,
	snackbar: snackbarReducer,
	loading: loadingReducer,
	site: siteReducer,
	user_profile: userProfileReducer,
	questionnaire_template: questionnaireTemplateReducer,
	annotation_template: annotationTemplateReducer,
	patient: patientReducer,
	study: studyReducer,
	job: jobReducer,
});

const rootReducer = (
	state: ReturnType<typeof appReducers> | undefined,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
) => {
	return appReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [
					FLUSH,
					REHYDRATE,
					PAUSE,
					PERSIST,
					PURGE,
					REGISTER,
				],
			},
		}),
});

const persistor = persistStore(store);

export { persistor, store };

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
